import React from "react";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginAuthen } from "../features/loginAuthenReducer";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#ffffff",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#000000" : "#308fe8",
  },
}));

const Loading = () => {
  const [progress, setProgress] = React.useState(0);
  const dispatch = useDispatch();
  const [serachParams, setSearchParams] = useSearchParams();

  const token = serachParams.get("token") || "";

  React.useEffect(() => {
    dispatch(loginAuthen(token));
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return window.location.replace("/dashboard")
        }
        return Math.min(oldProgress + Math.random() * 10, 100);
      });
    }, 100);

    return () => {
      clearInterval(timer);
    };
  }, [dispatch]);
  return (
    <div className="min-w-screen min-h-screen bg-gradient-to-r from-[#f8eede] to-[#b3853e] grid justify-items-center ">
      <img
        className="animate-bounce mt-20"
        src="./logo.png"
        alt="logo"
        width="400"
      />
      <Box sx={{ width: "100%", paddingX: "10%" }}>
        <BorderLinearProgress variant="determinate" value={progress} />
      </Box>
    </div>
  );
};

export default Loading;
